import React from "react";
import { AuthorContentPostFragment } from "../../types/graphql";
import {
  Author,
  AuthorImage,
  AuthorText,
  AuthorName,
  AuthorTextWrapper,
  AuthorLink,
  AuthorSuffix,
} from "./hero-content-post.styled";
import { linkTo } from "../../utils/contentUtils";

interface IHeroContentAuthorProps {
  author: AuthorContentPostFragment | undefined | null;
  type: "author" | "editor";
}

const HeroContentPostAuthor = (props: IHeroContentAuthorProps) => {
  const { author, type } = props;

  const authorImage = author && author.image && author.image?.url && (
    <AuthorImage
      src={author.image.url}
      alt={author.image.alt || `${author.name} - Xometry Contributor`}
    />
  );

  return (
    (author && (
      <Author>
        {author.image?.url && (
          <>
            {author.author_page && author.author_page?.document ? (
              <AuthorLink to={linkTo(author.author_page?.document)}>
                {authorImage}
              </AuthorLink>
            ) : (
              <>{authorImage}</>
            )}
          </>
        )}
        <AuthorTextWrapper>
          {author.name && (
            <AuthorText>
              {type === "editor" ? "Updated by" : "Written by"}
              <AuthorName>
                {author.author_page && author.author_page?.document ? (
                  <AuthorLink to={linkTo(author.author_page?.document)}>
                    {author.honorific_prefix && `${author.honorific_prefix} `}
                    {author.name}
                    {author.honorific_suffix && (
                      <AuthorSuffix> {author.honorific_suffix}</AuthorSuffix>
                    )}
                  </AuthorLink>
                ) : (
                  <>{author.name}</>
                )}
              </AuthorName>
            </AuthorText>
          )}
        </AuthorTextWrapper>
      </Author>
    )) || <></>
  );
};

export default HeroContentPostAuthor;
